import styled from "styled-components";

const Container = styled.div`
  width: 900px;
  max-width: 100%;
  margin: auto;
`;

export default Container;
